import { render, staticRenderFns } from "./KeyhandForm.vue?vue&type=template&id=2c836e8b&scoped=true&"
import script from "./KeyhandForm.vue?vue&type=script&lang=js&"
export * from "./KeyhandForm.vue?vue&type=script&lang=js&"
import style0 from "./KeyhandForm.vue?vue&type=style&index=0&id=2c836e8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c836e8b",
  null
  
)

export default component.exports